import React, { Component } from "react";

class linkAccountStepOne extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // checkboxState: false,
    };
  }

  render() {
    return (
      <div>
        <h2 className="text-center tab-h">Link Account</h2>
        <h3 className="text-center tab-h3">Select your account type</h3>
        {this.props.recieveGetTranscardPaymentMethods &&
          this.props.recieveGetTranscardPaymentMethods.map(
            (recieveGetTranscardPaymentMethods) => (
              <div>
                <input
                  id="Email"
                  name="totalTaxId"
                  placeholder="Payment Method"
                  type="checkbox"
                  value={this.props.checkboxState}
                  checked={this.props.checkboxState}
                  onChange={this.props.handleCheckBoxFirstStep}
                  className="validate checkinput"
                />
                <label className="active checkinput-label" htmlFor="Email">
                  {recieveGetTranscardPaymentMethods.description}
                </label>
              </div>
            )
          )}
      </div>
    );
  }
}

export default linkAccountStepOne;
